import React from 'react';
import EyeIcon from 'src/common/utils/TableColumnIcons/EyeIcon';

export const DetailColumnFormat = (value, row, rowIndex, { onEye }) => {
	return (
		<>
			<EyeIcon onClick={() => onEye(value)} color="primary" />
		</>
	);
};
